export default {
  page: { method: 'get', url: '/statement/page' }, // 流水分页
  summary: { method: 'get', url: '/statement' } // 资产汇总
}
